// export const API_URL = 'http://localhost:5000';
// export const API_URL = 'https://pro-investor-back.onrender.com'; //123
export const API_URL = 'https://cdn.24rusinvest.ru';